module.exports = __webpack_public_path__ + "img/game_tiyu_sinuoke.c995a9d0.png";